/**
 * @desc 查询中台系统订单退货单品明细
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.asMaterialRejectBillFacadeImpl.loadBySoOrderNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/loadBySoOrderNo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
